import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-20005
 */
export const USE_EDITOR_MODE_FROM_REQUEST_PARAMS = getFeature('use-editor-mode-from-request-params') || false;
